import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FirmaComponent } from './firma/firma.component';
import { FirmaExternaComponent } from './firma-externa/firma-externa.component';
import { PlantillasComponent } from './plantillas/plantilla.component';
import { AdminLoteComponent } from './admin-lote/admin-lote.component';
import { AdminPlantillaComponent } from './admin-planitlla/admin-plantilla.component';
import { FirmantesComponent } from './firmantes/firmantes.component';
import { AdminSimpleComponent } from './admin-simple/admin-simple.component';
import { adminGuard } from 'src/app/guards/admin.guard';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'firma/:id', // <-- ¡Aquí agregamos el parámetro :id!
        component: FirmaComponent,
        data: {
          title: "Firma365",
          breadcrumb: "Firma365"
        },
        canActivate: [adminGuard]
      },
      {
        path: 'plantillas/:id', // <-- ¡Aquí agregamos el parámetro :id!
        component: PlantillasComponent,
        data: {
          title: "Firma365",
          breadcrumb: "Firma365"
        },
      },
      {
        path: 'plantillas',
        component: PlantillasComponent,
        data: {
          title: "Plantillas",
          breadcrumb: "Plantillas"
        },
      },
      {
        path: 'admin-simple',
        component: AdminSimpleComponent,
        data: {
          title: "Admin Lotes",
          breadcrumb: "Admin Lotes"
        },
      },
      {
        path: 'admin-simple/:id',
        component: AdminSimpleComponent,
        data: {
          title: "Admin Lotes",
          breadcrumb: "Admin Lotes"
        }
      },
      {
        path: 'admin-lotes',
        component: AdminLoteComponent,
        data: {
          title: "Admin Lotes",
          breadcrumb: "Admin Lotes"
        }
      },
      {
        path: 'admin-plantillas',
        component: AdminPlantillaComponent,
        data: {
          title: "Admin Plantillas",
          breadcrumb: "Admin Plantillas"
        }
      },
      {
        path: 'firma-externa/:id', // <-- ¡Aquí agregamos el parámetro :id!
        component: FirmaExternaComponent,
        data: {
          title: "Firma365",
          breadcrumb: "Firma365"
        },
      },
      {
        path: 'firma-externa', // <-- ¡Aquí agregamos el parámetro :id!
        component: FirmaExternaComponent,
        data: {
          title: "Firma365",
          breadcrumb: "Firma365"
        },
      },
      {
        path: 'firmantes/:id',
        component:  FirmantesComponent  ,
        data: {
          title: "Firmantes",
          breadcrumb: "Firmantes"
        }
      },
      {
        path: ':id',
        component: FirmaComponent,
        data: {
          title: "Firma365",
          breadcrumb: "Firma365"
        }
      },   
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FirmasRoutingModule { }
